import { TableHead, TableRow, TableCell } from '@occc-app/design-system';

export const PastSubmissionsTableHead = () => (
  <TableHead>
    <TableRow>
      <TableCell>Submission Date</TableCell>
      <TableCell>Type</TableCell>
      <TableCell>Transactions Reported</TableCell>
      <TableCell>Submission Groups</TableCell>
      <TableCell>File Status</TableCell>
      <TableCell>Estimated Reimbursement</TableCell>
      <TableCell align='right'></TableCell>
    </TableRow>
  </TableHead>
);
